export const italianMessages = {
	en: 'English',
	he: 'עברית',
	pt: 'Português',
	es: 'Espanhol',
	it: 'Italiano',
	PROFILE_IMAGE: 'Foto di profilo',
	NAME: 'Nome',
	PRICE: 'Prezzo',
	SEARCH: 'Ricerca',
	IS_READ: 'Visualizzato',
	DATE: 'Data',
	DASHBOARD_WELCOME: 'Benvenuti al pannello di gestione',
	DASHBOARD: 'Dashboard',
	MONTHLY_REVENUE: 'Entrata mensile',
	NEW_ORDERS: 'Nuovi ordini',
	MONTH_HISTORY: 'Nuovi utenti che si sono uniti negli ultimi 30 giorni',
	VEHICLE_COLORS: 'Colori della vettura',
	LEADS: 'Clienti potenziali',
	FROM_DATE: 'Dal giorno',
	TO_DATE: 'Fino a giorno',
	GENDER: 'Sesso',
	FULL_NAME: 'Nome e cognome',
	HAS_CREDIT: 'Esiste un credito',
	BUDGET: 'Budget',
	TOTAL: 'Totale',
	VEHICLE_COLOR: 'Colore della vettura',
	FROM_CREATED_AT: 'Prodotti dal',
	TO_CREATED_AT: 'Prodotti fino al',
	TRAINING_MENU: 'Programma di allenamento',
	TRAINING_MENUS: 'File di nutrizione',

	ORGANIZATION: 'Organizzazione',
	ORGANIZATIONS: 'Organizzazioni',
	TRAINEE: 'Cliente',
	TRAINEES: 'Clienti',

	COACH: 'Coach',
	COACHES: 'Coaches',

	RECIPE_CATEGORY: 'Categoria della ricetta',
	RECIPE_CATEGORIES: 'Categorie delle ricette',

	RECIPE: 'Ricetta',
	RECIPES: 'Ricette',

	TAG: 'etichetta',
	TAGS: 'tag',

	PRODUCT: 'Prodotto',
	PRODUCTS: 'Prodotti',

	PRODUCT_CATEGORY: 'Categoria del prodotto',
	PRODUCT_CATEGORIES: 'Categorie dei prodotti',

	MARATHON: 'Maratona',
	MARATHONS: 'Maratone',

	DYNAMIC_CARD: 'Categoria dinamica',
	DYNAMIC_CARDS: 'Categorie dinamiche',

	BILLBOARD: 'Annuncio',
	BILLBOARDS: 'Banner',

	TRAINING: 'Allenamento',
	TRAININGS: 'Allenamenti',

	LIVE_TRAINING: 'Live Training',
	LIVE_TRAININGS: 'Live Trainings',

	LIVE_TRAININGS_MESSAGE: 'Live Training Message',
	LIVE_TRAININGS_MESSAGES: 'Live Training Messages',

	START_HOUR: 'Start Hour',
	END_HOUR: 'End Hour',

	TRAINING_CATEGORY: 'Categoria di allenamento',
	TRAINING_CATEGORIES: 'Categorie di allenamenti',

	SUCCESS_STORY_CATEGORY: 'Categoria di una storia di successo',
	SUCCESS_STORY_CATEGORIES: 'Categorie di storie di successo',
	SUCCESS_STORY: 'Storia di successo',
	SUCCESS_STORIES: 'Storie di successo',
	IMAGE: 'Foto',
	DESCRIPTION: 'Descrizione',
	ABOUT_ORGANIZATION: 'Parla dell’organizzazione',
	Male: 'Maschile',
	Female: 'Femminile',
	FEATURED_IMAGE: 'Foto principale',
	TITLE: 'Titolo',
	CONTENT: 'Contenuto',
	CATEGORY: 'Categoria',
	CREATED_BY: 'Prodotto da',
	GALLERY: 'Galleria',
	DYNAMIC_CATEGORY_DEFAULT_IMAGE: 'Foto principale delle categorie dinamiche',
	LOGO_IMAGE: 'Logo',
	ADDRESS: 'Indirizzo',
	MARATHONS_FLAG: 'Le maratone sono attivate?',
	SUCCESS_STORY_FLAG: 'Se consentire ai formatori di creare storie di successo tramite l\'app',
	COACH_FOLDER_FLAG: 'Coaches folder is publicly for all trainees?',
	COACH_REMINDER_EVERY: 'Ricordare agli coaches una volta ogni...',
	COACH_REMINDER_EVERY_TYPE: 'Periodo',
	TRAINEE_REMINDER_EVERY: 'Ricordare agli clienti una volta ogni...',
	TRAINEE_REMINDER_EVERY_TYPE: 'Periodo',
	FEATURED_IMAGE_URL: 'Foto principale',
	AGENDA: 'Programma',
	DURATION: 'giorni',
	PHONE: 'Telefono',
	MENU_PDF_URL: 'Menù',
	BIRTH_DATE: 'Data di nascita',
	EMAIL: 'Email',
	HEIGHT: 'Altezza',
	WEIGHT: 'Peso',
	TRAINING_TYPE: 'Tipo di allenamento',
	APPROVED_BY_COACH: 'Approvati dall’coach?',
	SHOULD_RECEIVE_MOTIVATION_NOTIFICATIONS: 'Avviso in materia di motivazione?',
	SHOULD_RECEIVE_WEIGHTING_REMINDER: 'Avviso di pesarsi?',
	SHOULD_RECEIVE_SENDING_IMAGE_REMINDER: 'Avviso di foto del peso?',
	SHOULD_COACH_RECEIVE_PERSONAL_MESSAGES_REMINDER: 'Coach - avviso in materia di annunci di privacy per gli clienti?',
	SHOULD_COACH_RECEIVE_TRAINEES_PROGRESS_REMINDER: 'Coach - avviso in materia di progresso dell’cliente?',
	SHOULD_COACH_RECEIVE_BIRTHDAY_NOTIFICATIONS: 'Coach - avviso in materia di compleanni?',
	SHOULD_COACH_RECEIVE_NON_UPLOADERS_REMINDER: 'Coach - avviso in materia di clienti che non si sono pesati?',
	NOTE: 'Nota',
	VIDEO: 'Video',
	VIDEO_LINK: 'Link al video',
	YOUTUBE_LINK: 'Link a YouTube',
	EXTERNAL_LINK: 'External Link',
	ORDER: 'Order',
	CARBS: 'Carboidrati',
	PROTEINS: 'Proteine',
	LINK: 'Link',
	NUMBER_OF_PARTICIPANTS: 'Numero di partecipanti',
	TOTAL_ACTIVE_MARATHONS: 'Maratone',
	TOTAL_ACTIVE_COACHES: 'Coach',
	TOTAL_ACTIVE_TRAINEES: 'clienti',
	TOTAL_CLIENTS: 'Totale clienti',
	ORGANIZATION_SETTINGS: 'Definizione dell’organizzazione',
	Admin: 'Amministratore',
	Regular: 'Normale',
	EQUALS: 'Uguale',
	CONTAINS: 'Contiene',
	BETWEEN: 'nel frattempo',
	Pending: 'In attesa',
	Approved: 'Approvato',
	SMS: 'SMS',
	Email: 'Email',
	All: 'Tutto',
	Toning: 'Fitness',
	Mass: 'Massa',
	Coach: 'Coach',
	Trainee: 'Cliente',
	Organization: 'Organizzazione',
	Vegetarian: 'Vegano',
	Hours: 'ore',
	Days: 'giorni',
	DAY: 'giorno',
	Weeks: 'settimane',
	Months: 'mesi',
	LANGUAGE: 'Lingua',
	HEBREW: 'Ebraico',
	ENGLISH: 'Inglese',
	ITALIAN: 'Italiano',
	TOTAL_COACHES_CREATED: 'Clienti che sono diventati coaches',
	MAX_NO_WEIGHT_DAYS: 'Ogni quanti giorni un cliente deve pesarsi?',
	COACH_BIRTHDAY_MESSAGE: 'Messaggio di compleanno',
	COACH_NEED_TO_WEIGHT_MESSAGE: 'Messaggio per un Coach quando un cliente non si è pesato per un periodo',
	COACH_FOLLOW_UP_MESSAGE: 'Messaggio di follow-up di un cliente per un Coach',
	TRAINEE_BIRTHDAY_MESSAGE: 'Che messaggio riceverà un cliente per il compleanno?',
	TRAINEE_NEED_TO_WEIGHT_MESSAGE: 'Che messaggio riceverà un cliente dopo un periodo durante il quale non si è pesato?',
	MARATHON_WEIGHTING_REMINDER_MESSAGE: 'Contenuto del messaggio che ricorda di pesarsi nel corso della maratona',
	COACHES_MARATHON_WEIGHTING_REMINDER_MESSAGE: 'Coaches need to collect weightings message',
	ORGANIZATIONAL_FOLLOW_UPS: 'Quanto un Coach deve eseguire follow-up? (diviso da virgole)',
	MENU_FILE: 'File del programma',
	TYPE: 'Tipo di allenamento',
	FROM_BMR: 'Da BMR',
	TO_BMR: 'Fino a BMR',
	SEND: 'Invio',
	ALL: 'Tutti',
	SEND_NOTIFICATIONS_TO_CLIENT: 'Invio di un messaggio push ai clienti',
	SUCCESSFULLY_SENT_NOTIFICATION_TO_ALL: 'Avviso inviato con successo!',
	NOTIFICATIONS: 'Messaggi push',
	GROUP_LINK: 'Link al gruppo',
	SPANISH: 'Spagnolo',
	PORTUGEUSE: 'Portoghese',
	FILE: 'File',
	VERIFICATION: 'Verification code',
	VERIFICATION_CODE: 'Verification code',
	VERIFICATIONS: 'Verification codes',
	SUPPORTED_LANGUAGES: 'Lingue supportate',
	DEFAULT_LANGUAGE: 'Lingua predefinita',
	general: {
		error: 'Errore generico'
	},
	message: {
		error: 'Errore generico'
	},
	error: {
		general: 'Errore generico',
		request: {
			invalid_req_params: 'Sono stati inviati dati non corretti'
		},
		files: {
			empty: 'Non è stato inviato un file',
			unsupported_ext: 'Suffisso del file non supportato'
		},
		auth: {
			wrong_credentials: 'Dati di identificazione non validi',
			not_admin: 'Non ci sono autorizzazioni di amministratore',
			not_client: 'Non ci sono autorizzazioni di cliente',
			failed_authenticating_jwt: 'Utente non identificato',
			not_registered: 'Utente non esistente',
			invalid_token: 'Utente scaduto'
		}
	},
	resources: {
		'verification': { name: 'Verification code' },
		'verifications': { name: 'Verification codes' },

		'training-menu': { name: 'תכנית אימון' },
		'training-menus': { name: 'תכניות אימונים' },

		'organization': { name: 'ארגון' },
		'organizations': { name: 'ארגונים' },

		'trainee': { name: 'מתאמן' },
		'trainees': { name: 'מתאמנים' },

		'coach': { name: 'מאמן' },
		'coaches': { name: 'מאמנים' },

		'recipe-category': { name: 'קטגוריית ממתכון' },
		'recipe-categories': { name: 'קטגוריות ממתכונים' },

		'recipe': { name: 'מתכון' },
		'recipes': { name: 'מתכונים' },

		'product': { name: 'מוצר' },
		'products': { name: 'מוצרים' },

		'product-category': { name: 'קטגוריית מוצר' },
		'product-categories': { name: 'קטגוריות מוצרים' },

		'marathon': { name: 'מרתון' },
		'marathons': { name: 'מרתונים' },

		'dynamic-card': { name: 'קטגוריה דינאמית' },
		'dynamic-cards': { name: 'קטגוריות דינאמיות' },

		'billboard': { name: 'מודעה' },
		'billboards': { name: 'באנרים' },

		'training': { name: 'אימון' },
		'trainings': { name: 'אימונים' },

		'training-category': { name: 'קטגוריית אימון' },
		'training-categories': { name: 'קטגוריות אימונים' },

		'success-story-category': { name: 'קטגוריית סיפור הצלחה' },
		'success-story-categories': { name: 'קטגוריות סיפורי הצלחה' },
		'success-story': { name: 'סיפור הצלחה' },
		'success-stories': { name: 'סיפורי הצלחה' },
		'vehicle-color': { name: 'צבע רכב' },
		'lead': { name: 'ליד' }
	},
	ra: {
		action: {
			clear_input_value: 'Pulisci',
			delete: 'Cancella',
			unselect: 'Annulla la scelta',
			sort: 'Ordina',
			show: 'Visualizza',
			undo: 'Ripristina',
			confirm: 'OK',
			bulk_actions: 'Sono stati scelti %{smart_count} elementi',
			list: 'Elenco',
			export: 'Esporta',
			save: 'Salva',
			create: 'Crea',
			edit: 'Modifica',
			cancel: 'Annulla',
			refresh: 'Aggiorna',
			add_filter: 'Aggiungi filtro',
			remove_filter: 'Rimuovi filtro',
			back: 'Torna'
		},
		boolean: {
			true: 'Sì',
			false: 'No'
		},
		page: {
			list: 'Elenco di %{name}',
			edit: '%{name} #%{id}',
			show: '%{name} #%{id}',
			empty: 'Non sono stati trovati risultati',
			invite: 'Speriamo che arrivino qui informazioni entro pochissimo tempo',
			create: 'Crea %{name}',
			delete: 'Cancella %{name} #%{id}',
			dashboard: 'Dashboard',
			not_found: 'Non esiste',
			error: 'Errore'
		},
		input: {
			references: {
				single_missing: 'Manca'
			},
			file: {
				upload_several:
					'Trascina alcuni file da caricare o clicca per sceglierne uno.',
				upload_single: 'Trascina un file da caricare o clicca per sceglierne uno.'
			},
			image: {
				upload_several:
					'Trascina alcune foto da caricare o clicca per sceglierne una.',
				upload_single:
					'Trascina una foto da caricare o clicca per sceglierne una.'
			}
		},
		message: {
			error: 'Ops... Si è verificato un errore',
			invalid_form: 'Modulo non corretto',
			yes: 'Sì',
			no: 'No',
			are_you_sure: 'Sei sicuro/a?',
			about: 'Informazioni',
			not_found:
				'Hai digitato un indirizzo errato o hai cliccato su un link non valido',
			delete_title: 'Cancella',
			delete_content: 'Sei sicuro/a di voler cancellare?',
			bulk_delete_title: 'Nota!',
			bulk_delete_content: 'Sei sicuro/a di voler cancellare tutte queste informazioni?'
		},
		navigation: {
			no_results: 'Non sono stati trovati risultati',
			page_rows_per_page: 'Numero di riga in ogni pagina',
			skip_nav: 'Salta',
			page_out_of_boundaries: 'Pagina %{page} fuori dai limiti',
			page_out_from_end: 'Impossibile continuare oltre l’ultima pagina',
			page_out_from_begin: 'Impossibile accedere prima della prima pagina',
			page_range_info: '%{offsetBegin}-%{offsetEnd} di %{total}',
			next: 'Successivo',
			prev: 'Precedente'
		},
		auth: {
			username: 'Nome utente',
			password: 'Password',
			sign_in: 'Accesso',
			sign_in_error: 'L’accesso non è riuscito, riprova',
			logout: 'Disconnessione',
			auth_check_error: 'Identificazione non riuscita'
		},
		notification: {
			data_provider_error: 'Errore nella comunicazione elettronica',
			updated: 'L’elemento è stato aggiornato con successo',
			created: 'L’elemento è stato creato con successo',
			deleted: 'L’elemento è stato cancellato con successo',
			item_doesnt_exist: 'Elemento inesistente',
			http_error: 'Errore nella comunicazione con il server'
		},
		validation: {
			required: 'Campo obbligatorio',
			minLength: 'Deve contenere almeno %{min} caratteri',
			maxLength: 'Può contenere al massimo %{max} caratteri',
			minValue: 'Deve essere di almeno %{min}',
			maxValue: 'Deve essere di %{max} o meno',
			number: 'Deve essere un numero',
			email: 'Indirizzo di posta elettronica non valido'
		}
	}
};
